import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCMiEI8vo6H3_AkOr-6DoArIFcH64lMBT0",
  authDomain: "wajls-9d7ba.firebaseapp.com",
  projectId: "wajls-9d7ba",
  storageBucket: "wajls-9d7ba.firebasestorage.app",
  messagingSenderId: "253767077366",
  appId: "1:253767077366:web:bb8b7a3144e0a515350bd7",
  measurementId: "G-JX28MRT9E1"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const database = getDatabase(app);
const analytics = getAnalytics(app);

export { storage, database };
